import { CbhFeatureFlag, useCbhFlag } from "../FeatureFlags";

export function useNlcStates() {
  const rawValue = useCbhFlag(CbhFeatureFlag.NLC_STATES, {
    defaultValue: {
      active_states: [],
    },
  });

  return new Set(rawValue.active_states ?? []);
}
